import { ResolveFn } from '@angular/router';
import {inject} from "@angular/core";
import {TagService} from "../services/tag.service";
import {Tag} from "../models/tag";

export const tagResolver: ResolveFn<Tag> = (route, state) => {
  const tagId = route.paramMap.get('tag');
  return inject(TagService).detail(+tagId!);
};
